import { DayPicker } from 'react-day-picker';
import styled, { css } from 'styled-components';

export const PickerCard = styled.div`
  width: 100%;
  max-width: 860px;
  border-radius: 8px;
  background: #ffffff;
  padding: 16px;
  box-shadow: 0px 28px 80px rgba(15, 23, 42, 0.18);

  @media (max-width: 768px) {
    border-radius: 8px;
    padding: 18px 14px 12px;
    max-width: 530px;
    width: 100%;
  }
`;

export const DatePickerLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;

  @media (max-width: 767px) {
    height: 100%;
  }
`;

export const DatePickerFixedTop = styled.div`
  background: #ffffff;
  z-index: 5;

  @media (max-width: 767px) {
    position: sticky;
    top: 0;
    padding-bottom: 12px;
  }
`;

export const InputGrid = styled.div<{ $columnCount: number }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  width: 100%;

  @media (min-width: 768px) {
    grid-template-columns: repeat(${({ $columnCount }) => $columnCount}, minmax(0, 1fr));
    gap: 24px;
    width: 100%;
    max-width: 100%;
  }
`;

export const InputButton = styled.div`
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;

export const InputLabel = styled.p`
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 500;
  color: #1d1d1f;

  @media (min-width: 768px) {
    font-size: 13px;
  }
`;

export const InputBox = styled.div<{
  $isActive: boolean;
  $hasValue: boolean;
}>`
  display: flex;
  min-height: 40px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid;
  padding: 9px 12px;
  font-size: 14px;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  ${({ $isActive, $hasValue }) =>
    $isActive
      ? css`
          border-color: #e6a23c;
          background: #ffffff;
        `
      : $hasValue
        ? css`
            border-color: #e8eaee;
            background: #ffffff;
          `
        : css`
            border-color: #e8eaee;
            background: #f7f8fa;
          `}

  @media (min-width: 768px) {
    min-height: 40px;
    padding-left: 12px;
    padding-right: 12px;
  }

  svg {
    flex: 0 0 auto;
    width: 16px;
    height: 16px;
  }
`;

// export const StyledCalendarIcon = styled(CalendarIcon)`
//   width: 20px;
//   height: 20px;
//   flex-shrink: 0;
//   color: #8c93a3;
// `;

export const InputValue = styled.span<{ $hasValue: boolean }>`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 1;
  color: ${({ $hasValue }) => ($hasValue ? "#3A3D46" : "#9AA1AF")};

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

export const InputClearButton = styled.button`
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  border: 0;
  border-radius: 999px;
  background: #c8d0db;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  cursor: pointer;
  padding: 0;
`;

export const CalendarWrapper = styled.div`
  margin-top: 16px;

  @media (max-width: 767px) {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-bottom: 24px;
    margin-bottom: 0;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

// export const StyledDayPicker = styled(DayPicker)`
//   width: 100%;

//     .rdp-months {
//       display: grid;
//       grid-template-columns: repeat(2, minmax(0, 1fr));
//       gap: 48px;
//       width: 100%;
//     }

//   .rdp-month {
//     width: 100%;
//   }

//     .rdp-month_grid {
//       width: 100%;
//     }

//   .rdp-month_caption {
//     margin-bottom: 20px;
//     display: flex;
//     min-height: 44px;
//     align-items: center;
//     justify-content: center;
//   }


//   .rdp-caption_label {
//     font-size: 22px;
//     font-weight: 600;
//     letter-spacing: -0.03em;
//     color: #1d1d1f;
//   }

//   .rdp-nav {
//     margin-bottom: 16px;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//   }

//   .rdp-button_previous,
//   .rdp-button_next {
//     display: inline-flex;
//     height: 44px;
//     width: 44px;
//     align-items: center;
//     justify-content: center;
//     border-radius: 999px;
//     background: #f4f5f7;
//     color: #475467;
//     transition: background-color 0.2s ease;
//   }

//   .rdp-button_previous:hover,
//   .rdp-button_next:hover {
//     background: #eceff3;
//   }

//   .rdp-chevron {
//     width: 20px;
//     height: 20px;
//   }

//   .rdp-weekdays {
//     margin-bottom: 8px;
//   }

//   .rdp-weekday {
//     padding-bottom: 8px;
//     font-size: 14px;
//     font-weight: 500;
//     color: #6b7280;
//   }

//   .rdp-day {
//     padding: 0;
//     vertical-align: top;
//   }

//   .rdp-day_button {
//     width: 100%;
//   }

//   .rdp-outside {
//     visibility: hidden;
//   }

//   @media (min-width: 768px) {
//     .rdp-months {
//       flex-direction: row;
//       gap: 32px;
//     }

//     .rdp-month_caption {
//       margin-bottom: 24px;
//     }

//     .rdp-caption_label {
//       font-size: 24px;
//     }

//     .rdp-nav {
//       margin-bottom: 20px;
//     }

//     .rdp-weekday {
//       padding-bottom: 12px;
//       font-size: 15px;
//     }
//   }
// `;

export const StyledDayPicker = styled(DayPicker) <{ $visibleMonthCount: number }>`
  width: 100%;
  max-width: 100%;
  position: relative;

  .rdp-months {
    display: grid;
    grid-template-columns: repeat(${({ $visibleMonthCount }) => $visibleMonthCount}, minmax(0, 1fr));
    gap: 28px;
    width: 100%;
    max-width: 100%;

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      width: 100%;
    }
  }

  .rdp-month {
    width: 100%;
    max-width: 100%;
  }

  .rdp-month_grid {
    width: 100%;
    table-layout: fixed;
  }

  .rdp-month_caption {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
    min-height: 36px;
  }

  .rdp-caption_label {
    font-size: 17px;
    font-weight: 700;
    color: #1d1d1f;
    text-align: center;
  }

  .rdp-nav {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 36px;
    pointer-events: none;
    z-index: 5;
  }

  .rdp-button_previous,
  .rdp-button_next {
    position: absolute;
    top: 0;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 0;
    background: #f1f3f6;
    color: #202020;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
  }

  .rdp-button_previous {
    left: 0;
  }

  .rdp-button_next {
    right: 0;
  }

  .rdp-chevron {
    width: 18px;
    height: 18px;
  }

  .rdp-weekdays {
    margin-bottom: 6px;
  }

  .rdp-weekday {
    padding-bottom: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #667085;
  }

  .rdp-day {
    padding: 0;
    vertical-align: top;
    font-size: 13px !important;
  }

  .rdp-day_button {
    height: 50px;
    width: 100%;
  }

  .rdp-outside {
    visibility: hidden;
  }
`;

export const DayButton = styled.button<{
  $isDisabled: boolean;
  $isOutside: boolean;
}>`
  position: relative;
  display: flex;
  height: 50px;
  width: 100%;
  align-items: stretch;
  justify-content: center;
  padding: 4px 2px;
  text-align: center;
  background: transparent;
  border: none;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      cursor: not-allowed;
    `}

  ${({ $isOutside }) =>
    $isOutside &&
    css`
      visibility: hidden;
      pointer-events: none;
    `}

  @media (min-width: 768px) {
    height: 50px;
  }
`;

export const RangeBase = styled.span`
  pointer-events: none;
  position: absolute;
  top: 4px;
  bottom: 4px;
  background: #fff3e4;
`;

export const RangeMiddle = styled(RangeBase)`
  left: 0;
  right: 0;
`;

export const RangeStart = styled(RangeBase)`
  left: 50%;
  right: 0;
`;

export const RangeEnd = styled(RangeBase)`
  left: 0;
  right: 50%;
`;

export const DayInner = styled.div<{
  $isRangeEdge: boolean;
  $isRangeMiddle: boolean;
  $isDisabled: boolean;
}>`
  position: relative;
  z-index: 10;
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  padding: 0 4px;
  transition: background-color 0.2s ease, color 0.2s ease;

  ${({ $isRangeEdge }) =>
    $isRangeEdge
      ? css`
          background: #e6a23c;
          color: #ffffff;
        `
      : css`
          color: #202020;
        `}

  ${({ $isRangeEdge, $isRangeMiddle, $isDisabled }) =>
    !$isRangeEdge &&
    !$isRangeMiddle &&
    !$isDisabled &&
    css`
      &:hover {
        background: #f6f7f9;
      }
    `}

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      color: #d0d5dd;
    `}
`;

export const DayNumber = styled.span`
  font-size: 15px;
  font-weight: 600;
  line-height: 1;

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;

export const FareText = styled.span<{
  $isOutside: boolean;
  $isDisabled: boolean;
  $isRangeEdge: boolean;
  $isCheapest: boolean;
}>`
  margin-top: 8px;
  font-size: 10px;
  font-weight: 500;
  line-height: 1;

  ${({ $isOutside }) =>
    $isOutside &&
    css`
      color: transparent;
    `}

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      color: #d0d5dd !important;
    `}

  ${({ $isRangeEdge }) =>
    $isRangeEdge &&
    css`
      color: rgba(255, 255, 255, 0.9);
    `}

  ${({ $isRangeEdge, $isDisabled, $isCheapest }) =>
    !$isRangeEdge &&
    !$isDisabled &&
    css`
      color: ${$isCheapest ? "#23A26D" : "#98A2B3"};
    `}

  @media (min-width: 768px) {
    font-size: 11px;
  }
`;

export const FooterActions = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid #eef0f3;
  padding-top: 16px;

  @media (max-width: 767px) {
    position: sticky;
    bottom: 0;
    z-index: 6;
    margin-top: 0;
    padding: 12px 0 calc(8px + env(safe-area-inset-bottom));
    background: #ffffff;
  }
`;

export const ActionButton = styled.button`
  border: none;
  border-radius: 999px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.2s ease;
`;

export const CancelButton = styled(ActionButton)`
  background: #f3f4f6;
  color: #2b2f38;

  &:hover {
    background: #e6e8ec;
  }
`;

export const ApplyButton = styled(ActionButton)`
  background: #e6a23c;
  color: #ffffff;

  &:hover {
    background: #d79430;
  }

  &:disabled {
    cursor: not-allowed;
    background: #f3d7a7;
  }
`;
